// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  min-width: auto;
  min-height: auto;
  height: auto;
}

.static-page__container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin: 0;
  border: none;
  padding: var(--spacing6);
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.static-page__logo-mrdm {
  width: 122px;
  height: 36px;
  margin-bottom: var(--spacing5);
}

.static-page__title {
  font-size: 26px;
  color: #000;
  margin: 0 0 var(--spacing3) 0;
}

p.static-page__message {
  margin: 0 0 var(--spacing5) 0;
  margin-bottom: var(--spacing3);
}

.static-page__links > :not(:last-child) {
  margin-right: var(--spacing2);
}
.static-page__links {
  margin-bottom: var(--spacing3);
}

.static-page__logout-box {
  display: flex;
  flex-direction: column;
}

.static-page__login-info {
  margin-bottom: var(--spacing1);
}

@media only screen and (min-width: 768px) {
  body {
    background-color: rgb(var(--gray-color-2));
  }
  .static-page__container {
    max-width: 560px;
    height: fit-content;
    margin: 200px auto;
    border: 1px solid rgb(var(--gray-color-10));
    border-radius: 4px;
  }
}
.static-page__redirect {
  font-size: 18px;
  color: #000;
  margin-bottom: var(--spacing3);
}`, "",{"version":3,"sources":["webpack://./libs/shared/feature-static-pages/src/lib/shared/static-page.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EAEA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EAEA,sBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,YAAA;EAEA,8BAAA;AAJJ;;AAOA;EACI,eAAA;EACA,WAAA;EACA,6BAAA;AAJJ;;AAOA;EACI,6BAAA;EACA,8BAAA;AAJJ;;AAQI;EACI,6BAAA;AALR;AAGA;EAKI,8BAAA;AALJ;;AAQA;EACI,aAAA;EACA,sBAAA;AALJ;;AAQA;EACI,8BAAA;AALJ;;AAQA;EACI;IACI,0CAAA;EALN;EAQE;IACI,gBAAA;IACA,mBAAA;IACA,kBAAA;IAEA,2CAAA;IACA,kBAAA;EAPN;AACF;AAUA;EACI,eAAA;EACA,WAAA;EACA,8BAAA;AARJ","sourcesContent":["@use \"definitions\" as *;\n\nbody {\n    min-width: auto;\n    min-height: auto;\n    height: auto;\n}\n\n.static-page__container {\n    width: 100%;\n    height: 100%;\n\n    box-sizing: border-box;\n    margin: 0;\n    border: none;\n    padding: var(--spacing6);\n    display: flex;\n    flex-direction: column;\n\n    background-color: #fff;\n}\n\n.static-page__logo-mrdm {\n    width: 122px;\n    height: 36px;\n\n    margin-bottom: var(--spacing5);\n}\n\n.static-page__title {\n    font-size: 26px;\n    color: #000;\n    margin: 0 0 var(--spacing3) 0;\n}\n\np.static-page__message {\n    margin: 0 0 var(--spacing5) 0;\n    margin-bottom: var(--spacing3);\n}\n\n.static-page__links {\n    > :not(:last-child) {\n        margin-right: var(--spacing2);\n    }\n\n    margin-bottom: var(--spacing3);\n}\n\n.static-page__logout-box {\n    display: flex;\n    flex-direction: column;\n}\n\n.static-page__login-info {\n    margin-bottom: var(--spacing1);\n}\n\n@media only screen and (min-width: 768px) {\n    body {\n        background-color: lg-color(--gray-color-2);\n    }\n\n    .static-page__container {\n        max-width: 560px;\n        height: fit-content;\n        margin: 200px auto;\n\n        border: 1px solid lg-color(--gray-color-10);\n        border-radius: 4px;\n    }\n}\n\n.static-page__redirect {\n    font-size: 18px;\n    color: #000;\n    margin-bottom: var(--spacing3);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
